// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageHeading-module__heading___4kV4o"};